import { render, staticRenderFns } from "./AdminStitchesScreen.vue?vue&type=template&id=3966fdc9&scoped=true&"
import script from "./AdminStitchesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminStitchesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3966fdc9",
  null
  
)

export default component.exports